import { ONE_SECOND, addTelemetryMetrics, setInterval } from '@datadog/browser-core';
export var MEASURES_PERIOD_DURATION = 10 * ONE_SECOND;
var currentPeriodMeasures;
var batchHasRumEvent;
export function startCustomerDataTelemetry(telemetry, lifeCycle, batchFlushObservable) {
  if (!telemetry.metricsEnabled) {
    return;
  }

  initCurrentPeriodMeasures();
  batchHasRumEvent = false; // We measure the data of every view updates even if there could only be one per batch due to the upsert
  // It means that contexts bytes count sums can be higher than it really is

  lifeCycle.subscribe(13
  /* LifeCycleEventType.RUM_EVENT_COLLECTED */
  , function () {
    batchHasRumEvent = true;
  });
  batchFlushObservable.subscribe(function (_ref) {
    var bytesCount = _ref.bytesCount,
        messagesCount = _ref.messagesCount;

    // Don't measure batch that only contains telemetry events to avoid batch sending loop
    // It could happen because after each batch we are adding a customer data measures telemetry event to the next one
    if (!batchHasRumEvent) {
      return;
    }

    batchHasRumEvent = false;
    currentPeriodMeasures.batchCount += 1;
    updateMeasure(currentPeriodMeasures.batchBytesCount, bytesCount);
    updateMeasure(currentPeriodMeasures.batchMessagesCount, messagesCount);
  });
  setInterval(sendCurrentPeriodMeasures, MEASURES_PERIOD_DURATION);
}

function sendCurrentPeriodMeasures() {
  if (currentPeriodMeasures.batchCount === 0) {
    return;
  } // monitor-until: forever


  addTelemetryMetrics("Customer data measures"
  /* TelemetryMetrics.CUSTOMER_DATA_METRIC_NAME */
  , currentPeriodMeasures);
  initCurrentPeriodMeasures();
}

function createMeasure() {
  return {
    min: Infinity,
    max: 0,
    sum: 0
  };
}

function updateMeasure(measure, value) {
  measure.sum += value;
  measure.min = Math.min(measure.min, value);
  measure.max = Math.max(measure.max, value);
}

function initCurrentPeriodMeasures() {
  currentPeriodMeasures = {
    batchCount: 0,
    batchBytesCount: createMeasure(),
    batchMessagesCount: createMeasure()
  };
}